import React from 'react';
import PropTypes from 'prop-types';
import Banner from 'zignal-landscape/lib/Banner';

import Styles from './DashboardSettingsModal.css';

const DashboardSettingsErrors = ({
  errors = {},
  onClearError
}) => {
  function handleAlertClick() {
    onClearError(errors.title ? 'title' : 'profiles');
  }

  return (
    <React.Fragment>
      {(errors.title || errors.profiles) && (
        <div className={Styles.errorWrapper} data-cy="dashboard-settings-error">
          <Banner
            bannerType="error"
            bannerStyle={'inline'}
            onClick={handleAlertClick}
            title={errors.title || errors.profiles}
          />
        </div>
      )}
    </React.Fragment>
  );
};

DashboardSettingsErrors.propTypes = {
  errors: PropTypes.any,
  onClearError: PropTypes.func
};

export default DashboardSettingsErrors;
